export default __webpack_public_path__ + "static/media/ads3.fc72e97a.jpg";